/** @format */

import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Button,
  Badge,
  Spinner,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import PrinterSettingsPage from "../Settings/Data/PrinterSettingPage"; // 👈 Import the new component

const PrintersPage = () => {
  const [printers, setPrinters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [activeTab, setActiveTab] = useState("general");

  const [receiptPrinter, setReceiptPrinter] = useState(
    localStorage.getItem("tbo_receipt_printer_name") || ""
  );
  const [labelPrinter, setLabelPrinter] = useState(
    localStorage.getItem("tbo_label_printer_name") || ""
  );

  useEffect(() => {
    fetch(`${process.env.REACT_APP_PRINT_API}/printers`)
      .then((res) => res.json())
      .then((data) => {
        setPrinters(data.printers || []);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch printers");
        console.error("Printer fetch error:", err);
        setLoading(false);
      });
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSetPrinter = (type, name) => {
    const key =
      type === "receipt"
        ? "tbo_receipt_printer_name"
        : "tbo_label_printer_name";

    localStorage.setItem(key, name);
    type === "receipt" ? setReceiptPrinter(name) : setLabelPrinter(name);
  };

  const renderPrinterTable = (type, selectedPrinter) => (
    <Table bordered hover responsive>
      <thead>
        <tr>
          <th>#</th>
          <th>Printer Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {printers.map((printer, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{printer}</td>
            <td>
              {selectedPrinter === printer ? (
                <Badge color="success">Default</Badge>
              ) : (
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => handleSetPrinter(type, printer)}
                >
                  Set as Default
                </Button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  return (
    <div className="page-body">
      <Container className="mt-4">
        <Row className="align-items-center mb-3">
          <Col>
            <h2 className="mb-0">Printer Settings</h2>
          </Col>
          <Col xs="auto">
            <Button 
              color="primary" 
              onClick={() => {
                const link = document.createElement('a');
                link.href = 'https://d1wwvg89fh4xli.cloudfront.net/tbo-print-server-v5.exe';
                link.download = 'tbo-print-server-v5.exe';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              Download Driver
            </Button>
          </Col>
        </Row>

        {error && <Alert color="danger">{error}</Alert>}
        {loading ? (
          <Spinner color="primary" />
        ) : (
          <>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "general" })}
                  onClick={() => toggleTab("general")}
                >
                  General
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "receipt" })}
                  onClick={() => toggleTab("receipt")}
                >
                  Receipt Printer
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "label" })}
                  onClick={() => toggleTab("label")}
                >
                  Label Printer
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "report" })}
                  onClick={() => toggleTab("report")}>
                  Report Printer
                </NavLink>
              </NavItem> */}
            </Nav>

            <TabContent activeTab={activeTab} className="mt-3">
              <TabPane tabId="general">
                <PrinterSettingsPage />
              </TabPane>
              <TabPane tabId="receipt">
                {renderPrinterTable("receipt", receiptPrinter)}
              </TabPane>
              <TabPane tabId="label">
                {renderPrinterTable("label", labelPrinter)}
              </TabPane>
              <TabPane tabId="report">
                {/* Placeholder for now */}
                <p>Report printer settings can be managed here later.</p>
              </TabPane>
            </TabContent>
          </>
        )}
      </Container>
    </div>
  );
};

export default PrintersPage;
